import { Option, ReadonlyArray } from 'effect';

export function toNonEmptyArray<A>(array: Array<A>): Option.Option<ReadonlyArray.NonEmptyArray<A>> {
  return ReadonlyArray.isNonEmptyArray(array) ? Option.some(array) : Option.none();
}
